/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_TitleInputs */

const en_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Center`)
};

const de_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfecenter`)
};

const fr_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre d'aide`)
};

const es_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de ayuda`)
};

const it_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro assistenza`)
};

const nl_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helpcentrum`)
};

const pl_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrum pomocy`)
};

const fi_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohjekeskus`)
};

const da_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjælpecenter`)
};

const sv_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjälpcenter`)
};

/**
* | output |
* | --- |
* | "Help Center" |
*
* @param {Help_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_title = /** @type {((inputs?: Help_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_title(inputs)
	if (locale === "fr") return fr_help_title(inputs)
	if (locale === "es") return es_help_title(inputs)
	if (locale === "it") return it_help_title(inputs)
	if (locale === "nl") return nl_help_title(inputs)
	if (locale === "pl") return pl_help_title(inputs)
	if (locale === "fi") return fi_help_title(inputs)
	if (locale === "da") return da_help_title(inputs)
	if (locale === "sv") return sv_help_title(inputs)
	return en_help_title(inputs)
});